export default __webpack_public_path__ + "static/media/resnetgrutable1.95a707de.png";